import React from "react";
import { Modal, Box, Typography } from "@mui/material";

function SetLoading({ imageSource, message = "Cargando..." }) {
    const image = imageSource ? imageSource : '/resources/static/reportautomator/img/icon-report-automator.svg';
    return (
        <Modal className="loading-modal-container" open={true}>
            <Box>
                <img
                    className="loading-image"
                    src={image}
                    alt="Loading animation"
                />
                <Typography className="pt-5 title" variant="h6">
                    {message}
                </Typography>
            </Box>
        </Modal>
    );
}

export default SetLoading;